import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import useReactRouter from 'use-react-router';
import MaterialTable from 'material-table';
import Switch from '@material-ui/core/Switch';
import { Button, Snackbar, TextField, FormControlLabel, Typography } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import SaveIcon from '@material-ui/icons/Save';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckIcon from '@material-ui/icons/Check';
import Input from '@material-ui/core/Input';

//Accordion

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


//Card
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

//Stepper

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';



//Merge
var merge = require('lodash.merge');
var unset = require('lodash.unset');

const theme = createMuiTheme({});

const useStyles = makeStyles(theme => ({
    div: {
        marginRight: '15px',
        // float: 'right',
    },

    //Stepper
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepperdiv: {
        marginRight: '15px',
        float: 'right',
    },

    //Accordion
    heading: {
        fontSize: theme.typography.pxToRem(17),
        fontWeight: theme.typography.fontWeightRegular,
    },
    //card
    cardroot: {
        minHeight: 465,
        height: '100%',
    },
}));

//Stepper

function getSteps() {
    return ['Item Config', 'View Config'];
}

//Alert

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EntitySearchResultForm(props) {
    const classes = useStyles();
    const { location, history } = useReactRouter();
    const reduxAuth = useSelector((state) => state.auth)
    const appcomponent = useSelector((state) => state.appcomponent)
    const dispatch = useDispatch();

    //success alert

    const [openalert, setOpenAlert] = React.useState({
        open: false,
        msg: 'Configuration Saved',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert({
            open: false,
        });
    };

    //Stepper
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();


    //Search Grid static JSON

    const [jsonObj] = React.useState({
        _id: '',
        componentContextCode: '',
        domain: '',
        entityType: '',
        context1: '',
        context2: '',
        context3: '',
        relationship: '',
        role: '',
        app: '',
        isDuplicate: '',
        environmentId: '',
        isDuplicate: false,
        isPublished: true,
        jsonDocument: {
            id: "",
            name: "",
            type: "",
            // properties:"",
            data: {
                contexts: [{
                    context: {
                        component: "_DEFAULT",
                        role: "_DEFAULT",
                        tenant: "_DEFAULT",
                        domain: "_DEFAULT",
                        app: "_DEFAULT",
                        entityType: "_DEFAULT",
                        country: "_DEFAULT",
                        channel: "_DEFAULT",
                        relationship: "_DEFAULT",
                        user: "_DEFAULT"
                    },
                    jsonData: {}
                }]
            }
        }
    })

    const handleNext = (event) => {
        if (event === 'Next') {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setOpenNextSelection({
                open: true
            })

        }
        else {
            reduxAuth.fullscreentoggle=false
            history.push('./Config')
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setOpenNextSelection({
            open: false
        })
    };
    //End Stepper

    const [openNextSelection, setOpenNextSelection] = React.useState({
        open: false
    })

    //Error Part
    const [nameError, setNameError] = React.useState({
        error: true,
        label: "Attribute Name is required.",
        helperText: "Attribute Name is required.",
        validateInput: true,
    });

    //Tile config state
    const [TileConfigtxt, setTileConfigtxt] = React.useState({
        titlePattern: '',
        subTitlePattern: ''
    })

    //handletileconfigtxt
    const handletileconfigtxt = (event, value) => {
        console.log("")
        setTileConfigtxt({
            ...TileConfigtxt,
            [event.currentTarget.name]: event.currentTarget.value
        })
    }

    //TenantAttribute List
    const [TenantAttributes, setTenantAttributes] = React.useState(appcomponent.attributeList)
    
    //Toolbarconfig Button
    const [ToolbarButtons, setToolbarButtons] = React.useState([])

    //Tile config column
    let [TileActionState, setTileActionState] = React.useState({
        columns: [
            { title: 'Name', field: 'name', editable: 'onAdd' },
            { title: 'Event Name', field: 'eventName' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handletileactions(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handletileactions(rowData)
                        }} />
                    }
                }
            },
        ]
    })

    //List state
    const [ListActions, setListActions] = React.useState([])

    //List config column
    let [ListActionsState, setListActionsState] = React.useState({
        columns: [
            { title: 'Name', field: 'name', editable: 'onAdd' },
            { title: 'Event Name', field: 'eventName' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handlelistactions(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handlelistactions(rowData)
                        }} />
                    }
                }
            },
        ]
    })

    //Tile state
    const [TileActions, setTileActions] = React.useState([])


    //View  Config Button Table
    let [btnstate, setbtnState] = React.useState({
        columns: [
            { title: 'Button Name', field: 'name', editable: 'onAdd' },
            { title: 'Button text', field: 'text' },
            { title: 'Tool Tip', field: 'tooltip' },
            { title: 'Display Sequence', field: 'displaySequence', type: 'numeric' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handletoolbarbtns(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handletoolbarbtns(rowData)
                        }} />
                    }
                }
            },
        ]
    })

    //Entity Search Grid Columns
    let [state, setState] = React.useState({
        columns: [
            {
                title: '', initialValue: false, render: rowData => {
                    if (rowData) {
                        if (rowData.isMetaDataColumn != true) {
                            return <DeleteOutlineIcon onClick={(event) => handledeleteattribute(rowData)}></DeleteOutlineIcon>
                        }
                    }
                }
            },
            {
                title: 'Attribute Name', field: 'name', editable: 'onAdd',
                cellStyle: {
                    width: 200,
                    minWidth: 200
                  },
                editComponent: props => (
                    <Autocomplete
                        id="Select Attribute"
                        name="Select Attribute"
                        size="small"
                        options={TenantAttributes}
                        onChange={(e, value) => {
                            if (nameError.validateInput) {
                                setNameError({
                                    ...nameError,
                                    validateInput: false,
                                });
                            }

                            props.onChange(value);
                        }}

                        getOptionLabel={option => option}
                        renderInput={params => (
                            <TextField
                                fullWidth
                                {...params}
                                variant="standard"
                                label="Select Attribute"
                                size="small"
                                placeholder="Select Attribute"
                                error={
                                    !props.value &&
                                        nameError.validateInput
                                        ? nameError.error
                                        : false
                                }
                                helperText={
                                    !props.value &&
                                        nameError.validateInput
                                        ? nameError.helperText
                                        : ""
                                }
                            />
                        )}
                        value={props.value ? props.value : ""}
                    />
                )
            },
            { title: 'Attribute Header', field: 'header', 
            cellStyle: {
                width: 200,
                minWidth: 200
              }, },
            { title: 'Link', field: 'linkTemplate'},
            { title: 'Display Sequence', field: 'displaySequence', type: 'numeric' },
            {
                title: 'Visible',
                field: 'visible',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.visible === "true" || rowData.visible === true) {

                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = false
                            handlesearchgridattributes(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.visible} onChange={(event) => {
                            rowData.visible = true
                            handlesearchgridattributes(rowData)
                        }} />
                    }
                }
            },
            {
                title: 'Filterable',
                field: 'filterable',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.filterable === "true" || rowData.filterable === true) {

                        return <Switch checked={rowData.filterable} onChange={(event) => {
                            rowData.filterable = false
                            handlesearchgridattributes(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.noTrim} onChange={(event) => {
                            rowData.noTrim = true
                            handlesearchgridattributes(rowData)
                        }} />
                    }
                }
            },
            {
                title: 'Sortable',
                field: 'sortable',
                editComponent: props => (
                    <Switch checked={props.value} onChange={e => props.onChange(!props.value)} />
                ),
                render: rowData => {
                    if (rowData.sortable === "true" || rowData.sortable === true) {

                        return <Switch checked={rowData.sortable} onChange={(event) => {
                            rowData.sortable = false
                            handlesearchgridattributes(rowData)
                        }} />
                    }
                    else {
                        return <Switch checked={rowData.sortable} onChange={(event) => {
                            rowData.sortable = true
                            handlesearchgridattributes(rowData)
                        }} />
                    }
                }
            },
           
        ]
    })

    //AttributeList
    const [AttributeList, setAttributeList] = React.useState([])

    //handlesearchgridattributes
    const handlesearchgridattributes = (newData) => {
        var oldlist = AttributeList;
        var newlist = oldlist.concat(newData);
        let addjson = {
            "config": {
                "gridConfig": {
                    "itemConfig": {
                        "fields": {
                            [newData.name]: newData
                        }
                    }

                }
            }
        }
        let mergejson = {};
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                getAttributeList();
                updateConfigAPI();


            }
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
                getAttributeList();
            }
        }

        if (location.state === undefined) {

            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
            location.state = jsonObj
            getAttributeList();
            updateConfigAPI("add");
            // history.push("./ManageConfig")

        }
        getAttributeList();
    }

    //handledeleteattribute Delete
    const handledeleteattribute = (rowData) => {
        let config = location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.itemConfig.fields;
        let del = unset(config, rowData.name)
        location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.itemConfig.fields = config
        getAttributeList();
        updateConfigAPI();
    }

    //handletoolbarbtns
    const handletoolbarbtns = (newData) => {
        var oldlist = ToolbarButtons;
        var newlist = oldlist.concat(newData);
        let addjson = {
            "config": {
                "gridConfig": {
                    "viewConfig": {
                        "toolbarConfig": {
                            "buttonItems": {
                                "basic": {
                                    "buttons": {
                                        [newData.name]: newData
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        let mergejson = {};
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                getViewConfig();
                updateConfigAPI();


            }
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
                getAttributeList();
            }

            if (location.state === undefined) {

                jsonObj.jsonDocument.id = props.data.computedName;
                jsonObj.jsonDocument.name = props.data.computedName;
                jsonObj.jsonDocument.type = "UiConfig";
                jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
                jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
                jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
                jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
                jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
                jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
                jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
                jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

                jsonObj._id = props.data._id;
                jsonObj.isPublished = false;
                jsonObj.componentContextCode = props.data.componentContextCode;
                jsonObj.domain = props.data.domain;
                jsonObj.entityType = props.data.entityType;
                jsonObj.context1 = props.data.context1;
                jsonObj.context2 = props.data.context2;
                jsonObj.context3 = props.data.context3;
                jsonObj.relationship = props.data.relationship;
                jsonObj.role = props.data.role;
                jsonObj.app = props.data.app;
                jsonObj.isDuplicate = props.data.isDuplicate;
                jsonObj.environmentId = props.data.environmentId;

                jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
                location.state = jsonObj
                getViewConfig();
                updateConfigAPI("add");
                // history.push("./ManageConfig")

            }
        }

    }

    //handletileactions
    const handletileactions = (newData) => {
        var oldlist = ToolbarButtons;
        var newlist = oldlist.concat(newData);
        let addjson = {
            "config": {
                "gridConfig": {
                    "viewConfig": {
                        "tile": {
                            "settings": {
                                "actions": {
                                    [newData.name]: newData
                                }
                            }
                        }
                    }
                }
            }
        }
        let mergejson = {};
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                getViewConfig();
                updateConfigAPI();


            }
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
                getAttributeList();
            }

            if (location.state === undefined) {

                jsonObj.jsonDocument.id = props.data.computedName;
                jsonObj.jsonDocument.name = props.data.computedName;
                jsonObj.jsonDocument.type = "UiConfig";
                jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
                jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
                jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
                jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
                jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
                jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
                jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
                jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

                jsonObj._id = props.data._id;
                jsonObj.isPublished = false;
                jsonObj.componentContextCode = props.data.componentContextCode;
                jsonObj.domain = props.data.domain;
                jsonObj.entityType = props.data.entityType;
                jsonObj.context1 = props.data.context1;
                jsonObj.context2 = props.data.context2;
                jsonObj.context3 = props.data.context3;
                jsonObj.relationship = props.data.relationship;
                jsonObj.role = props.data.role;
                jsonObj.app = props.data.app;
                jsonObj.isDuplicate = props.data.isDuplicate;
                jsonObj.environmentId = props.data.environmentId;

                jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
                location.state = jsonObj
                getViewConfig();
                updateConfigAPI("add");
                // history.push("./ManageConfig")

            }
        }
    }

    //handlelistactions
    const handlelistactions = (newData) => {
        var oldlist = ToolbarButtons;
        var newlist = oldlist.concat(newData);
        let addjson = {
            "config": {
                "gridConfig": {
                    "viewConfig": {
                        "list": {
                            "settings": {
                                "actions": {
                                    [newData.name]: newData
                                }
                            }
                        }
                    }
                }
            }
        }
        let mergejson = {};
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                getViewConfig();
                updateConfigAPI();


            }
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
                getAttributeList();
            }

            if (location.state === undefined) {

                jsonObj.jsonDocument.id = props.data.computedName;
                jsonObj.jsonDocument.name = props.data.computedName;
                jsonObj.jsonDocument.type = "UiConfig";
                jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
                jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
                jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
                jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
                jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
                jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
                jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
                jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

                jsonObj._id = props.data._id;
                jsonObj.isPublished = false;
                jsonObj.componentContextCode = props.data.componentContextCode;
                jsonObj.domain = props.data.domain;
                jsonObj.entityType = props.data.entityType;
                jsonObj.context1 = props.data.context1;
                jsonObj.context2 = props.data.context2;
                jsonObj.context3 = props.data.context3;
                jsonObj.relationship = props.data.relationship;
                jsonObj.role = props.data.role;
                jsonObj.app = props.data.app;
                jsonObj.isDuplicate = props.data.isDuplicate;
                jsonObj.environmentId = props.data.environmentId;

                jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
                location.state = jsonObj
                getViewConfig();
                updateConfigAPI("add");
                // history.push("./ManageConfig")

            }
        }
    }

    //handletilepattern
    const handletilepattern = () => {
        let addjson = {
            "config": {
                "gridConfig": {
                    "viewConfig": {
                        "tile": {
                            "settings":
                                TileConfigtxt
                        }
                    }
                }
            }
        }
        let mergejson = {};
        if (location.state) {
            if (location.state.jsonDocument != '') {
                let customconfig = location.state.jsonDocument.data.contexts[0].jsonData;
                mergejson = merge(customconfig, addjson)

                location.state.jsonDocument.data.contexts[0].jsonData = mergejson;
                getViewConfig();
                updateConfigAPI();


            }
            if (location.state.jsonDocument == '') {
                location.state.jsonDocument = jsonObj.jsonDocument
                location.state.jsonDocument.data.contexts[0].jsonData = addjson;
                updateConfigAPI();
                getAttributeList();
            }

            if (location.state === undefined) {

                jsonObj.jsonDocument.id = props.data.computedName;
                jsonObj.jsonDocument.name = props.data.computedName;
                jsonObj.jsonDocument.type = "UiConfig";
                jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
                jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
                jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
                jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
                jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
                jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
                jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
                jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

                jsonObj._id = props.data._id;
                jsonObj.isPublished = false;
                jsonObj.componentContextCode = props.data.componentContextCode;
                jsonObj.domain = props.data.domain;
                jsonObj.entityType = props.data.entityType;
                jsonObj.context1 = props.data.context1;
                jsonObj.context2 = props.data.context2;
                jsonObj.context3 = props.data.context3;
                jsonObj.relationship = props.data.relationship;
                jsonObj.role = props.data.role;
                jsonObj.app = props.data.app;
                jsonObj.isDuplicate = props.data.isDuplicate;
                jsonObj.environmentId = props.data.environmentId;

                jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
                location.state = jsonObj
                getViewConfig();
                updateConfigAPI("add");
                // history.push("./ManageConfig")

            }
        }
    }
    //update config API
    const updateConfigAPI = (event) => {

        //update Config

        let url = "configurationUpdate"
        let postdata = null;
        if (event === "add") {
            postdata = {
                _id: props.data._id,
                jsonDocument: jsonObj.jsonDocument,
                isPublished: false,
                componentContextCode: props.data.componentContextCode,
                domain: props.data.domain,
                entityType: props.data.entityType,
                context1: props.data.context1,
                context2: props.data.context2,
                context3: props.data.context3,
                relationship: props.data.relationship,
                role: props.data.role,
                app: props.data.app,
                isDuplicate: props.data.isDuplicate,
                environmentId: props.data.environmentId,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            };
        }
        else {
            location.state.isPublished = false;
            postdata = {
                ...location.state,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            }
        }


        axios.post(url, postdata)
            .then(editConfigResponse => {
                setOpenAlert({
                    open: true
                })
            })
            .catch(err => {
                console.log(err);
                if (typeof err.response != "object") {
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });

    }


    //Global
    let vartoolbarconfig = null
    let vartileconfig = null
    let varlistconfig = null

    //getViewConfig
    const getViewConfig = () => {
        let tmapconfig = null;
        let tilemergeconfig = null;
        let listmergeconfig = null
        tmapconfig = vartoolbarconfig
        tilemergeconfig = vartileconfig
        listmergeconfig = varlistconfig
        if (location.state) {
            if (location.state.jsonDocument != '') {
                try {
                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.hasOwnProperty("gridConfig")) {

                        if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.hasOwnProperty("viewConfig")) {
                            if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.hasOwnProperty("toolbarConfig")) {
                                if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.toolbarConfig.hasOwnProperty("buttonItems")) {
                                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.toolbarConfig.buttonItems.hasOwnProperty("basic")) {
                                        if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.toolbarConfig.buttonItems.basic.hasOwnProperty("buttons")) {
                                            let customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.toolbarConfig.buttonItems.basic.buttons
                                            tmapconfig = merge(vartoolbarconfig, customconfig)
                                        }
                                    }
                                }
                                else {
                                    tmapconfig = vartoolbarconfig;
                                }
                            }
                            //Tile
                            if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.hasOwnProperty("tile")) {
                                if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.hasOwnProperty("settings")) {
                                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("subTitlePattern") && location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("titlePattern")) {
                                        setTileConfigtxt({
                                            ...TileConfigtxt,
                                            titlePattern: location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.titlePattern,
                                            subTitlePattern: location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.subTitlePattern
                                        })
                                    }
                                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("subTitlePattern") && !location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("titlePattern")) {
                                        setTileConfigtxt({
                                            ...TileConfigtxt,
                                            subTitlePattern: location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.subTitlePattern
                                        })
                                    }
                                    if (!location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("subTitlePattern") && location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("titlePattern")) {
                                        setTileConfigtxt({
                                            ...TileConfigtxt,
                                            titlePattern: location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.titlePattern,
                                        })
                                    }

                                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.hasOwnProperty("actions")) {
                                        let customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.actions
                                        tilemergeconfig = merge(vartileconfig, customconfig)
                                    }
                                }
                            }
                            //List
                            if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.hasOwnProperty("list")) {
                                if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.list.hasOwnProperty("settings")) {
                                    // setTileConfigtxt({
                                    //     txt
                                    // })
                                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.list.settings.hasOwnProperty("actions")) {
                                        let customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.list.settings.actions
                                        listmergeconfig = merge(varlistconfig, customconfig)
                                    }
                                }
                            }
                        }

                    }
                    else {
                        tmapconfig = vartoolbarconfig;
                    }
                } catch (error) {
                    tmapconfig = vartoolbarconfig;
                }
            }
        }
        if (location.state === undefined) {
            tmapconfig = vartoolbarconfig
            tilemergeconfig = vartileconfig
            listmergeconfig = varlistconfig
        }
        let btnlist = Object.keys(tmapconfig).map((key) => {
            tmapconfig[key].name = key
            return tmapconfig[key]
        })
        setToolbarButtons(btnlist)

        let tileactionlist = Object.keys(tilemergeconfig).map((key) => {
            tilemergeconfig[key].name = key
            return tilemergeconfig[key]
        })
        setTileActions(tileactionlist)

        let listactionlist = Object.keys(listmergeconfig).map((key) => {
            listmergeconfig[key].name = key
            return listmergeconfig[key]
        })
        setListActions(listactionlist)
    }

    //getAttributeList
    const getAttributeList = () => {
        let baseconfig = null;
        let mapconfig = null;
        let url = "baseConfigurationGet"
        let postdata = {
            userId: reduxAuth.userId,
            token: reduxAuth.token,
            environmentId: appcomponent.selectedEnvironment.tenantId,
            componentContextCode: appcomponent.selectedComponent.componentContextCode
        }

        axios.post(url, postdata)
            .then(baseConfigResponse => {
                vartileconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.tile.settings.actions;
                varlistconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.list.settings.actions;
                vartoolbarconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config.gridConfig.viewConfig.toolbarConfig.buttonItems.basic.buttons;
                baseconfig = baseConfigResponse.data.response[0].jsonDocument.data.contexts[0].jsonData.config.gridConfig.itemConfig.fields;
                mapconfig = baseconfig;
                if (location.state) {
                    if (location.state.jsonDocument != '') {
                        try {
                            if (location.state.jsonDocument.data.contexts[0].jsonData.config.hasOwnProperty("gridConfig")) {

                                if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.hasOwnProperty("itemConfig")) {
                                    if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.itemConfig.hasOwnProperty("fields")) {
                                        if (location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.itemConfig.fields != {}) {
                                            let customconfig = location.state.jsonDocument.data.contexts[0].jsonData.config.gridConfig.itemConfig.fields;
                                            mapconfig = merge(baseconfig, customconfig)
                                        }
                                        else {
                                            mapconfig = baseconfig;
                                        }
                                    }
                                }

                            }
                            else {
                                mapconfig = baseconfig;
                            }
                        } catch (error) {
                            mapconfig = baseconfig;
                        }
                    }
                }
                if (location.state === undefined) {
                    mapconfig = baseconfig
                }

                let attributelist = Object.keys(mapconfig).map((key) => {
                    mapconfig[key].name = key
                    return mapconfig[key]
                })

                setAttributeList(attributelist)
                getViewConfig();
            })
    }


    useEffect(() => {
        getAttributeList();
    }, []);

    return (
        <div>
            {openalert.open ?
                <Snackbar
                    open={openalert.open} autoHideDuration={3000}
                    onClose={handleClose}>
                    <Alert
                        severity={"success"}
                        color={"info"}
                        variant="outlined">
                        Configuration Saved..
                        </Alert>
                </Snackbar>
                : null}
                {appcomponent.attributeList==null?
                     <Snackbar
                     open={true} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                     onClose={handleClose}>
                     <Alert
                         severity="error"
                         color="error"
                         variant="filled">
                             Couldn't found context list please sync the tenant...
                     </Alert>
                 </Snackbar>
                :null}
                  
            <div className={classes.root}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className={classes.stepperdiv}>
                    {activeStep === steps.length ? null : (
                        <div>
                            <div>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    className={classes.backButton}
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    startIcon={<ArrowBackIosIcon style={{ fontSize: 10 }} />}
                                >
                                    Back
                                 </Button>
                                <Button variant="contained"
                                    size="small"
                                    style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                    color="primary"
                                    onClick={() => handleNext(activeStep === steps.length - 1 ? 'Back To Search Result' : 'Next')}
                                    startIcon={activeStep === steps.length - 1 ? <SettingsBackupRestoreIcon /> : <NavigateNextIcon />}
                                >
                                    {activeStep === steps.length - 1 ? 'Back To Search Result' : 'Next'}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {openNextSelection.open ?
                <div style={{ marginTop: '40px' }}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header" >
                            <Typography className={classes.heading}>Toolbar Config</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MaterialTable
                                style={{ width: '100%' }}
                                title="Buttons"
                                columns={btnstate.columns}
                                data={ToolbarButtons}
                                options={{
                                    search: true,
                                    sorting: true,
                                    pageSize: 5,
                                    pageSizeOptions: [5, 10, 20, 50],
                                    padding:'dense'
                                }}
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            setTimeout(() => {
                                                resolve();
                                                handletoolbarbtns(newData);
                                            }, 600);
                                        }),
                                    onRowUpdate: (newData) =>
                                        new Promise((resolve) => {
                                            setTimeout(() => {
                                                resolve();
                                                handletoolbarbtns(newData);
                                            }, 600);
                                        })
                                }} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Typography className={classes.heading}>Tile Config</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <br></br>
                            <Input
                                fullWidth
                                id="Title Pattern"
                                type='text'
                                name="titlePattern"
                                style={{ border: '1px solid', borderRadius: '5px' }}
                                placeholder="Title Pattern"
                                value={TileConfigtxt.titlePattern}
                                onChange={handletileconfigtxt}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="titlePattern"
                                            onClick={handletilepattern}
                                        >
                                            <CheckIcon></CheckIcon>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />

                            <Input
                                fullWidth
                                id="subTitlePattern"
                                name="subTitlePattern"
                                type='text'
                                style={{ border: '1px solid', borderRadius: '5px' }}
                                placeholder="Sub Title Pattern"
                                value={TileConfigtxt.subTitlePattern}
                                onChange={handletileconfigtxt}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="subTitlePattern"
                                            onClick={handletilepattern}>
                                            <CheckIcon></CheckIcon>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </AccordionDetails>
                        <AccordionDetails>
                            <MaterialTable
                                style={{ width: '100%' }}
                                title="Actions"
                                columns={TileActionState.columns}
                                data={TileActions}
                                options={{
                                    search: true,
                                    sorting: true,
                                    pageSize: 5,
                                    pageSizeOptions: [5, 10, 20, 50],
                                    padding:'dense'
                                }}
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            setTimeout(() => {
                                                resolve();
                                                handletileactions(newData);
                                            }, 600);
                                        }),
                                    onRowUpdate: (newData) =>
                                        new Promise((resolve) => {
                                            setTimeout(() => {
                                                resolve();
                                                handletileactions(newData);
                                            }, 600);
                                        })
                                }} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header" >
                            <Typography className={classes.heading}>List Config</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MaterialTable
                                style={{ width: '100%' }}
                                title="Actions"
                                columns={ListActionsState.columns}
                                data={ListActions}
                                options={{
                                    search: true,
                                    sorting: true,
                                    pageSize: 5,
                                    pageSizeOptions: [5, 10, 20, 50],
                                    padding:'dense'
                                }}
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            setTimeout(() => {
                                                resolve();
                                                handlelistactions(newData);
                                            }, 600);
                                        }),
                                    onRowUpdate: (newData) =>
                                        new Promise((resolve) => {
                                            setTimeout(() => {
                                                resolve();
                                                handlelistactions(newData);
                                            }, 600);
                                        })
                                }} />
                        </AccordionDetails>
                    </Accordion>

                </div> :
                <div style={{ marginTop: '40px' }}>

                    <MaterialTable
                        title="Entity Search Grid Attributes"
                        columns={state.columns}
                        data={AttributeList}
                        options={{
                            search: true,
                            sorting: true,
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100],
                            padding:'dense'
                        }}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        if (!newData.name) {
                                            setNameError({
                                                error: true,
                                                label: "required",
                                                helperText: "Attribute Name is required.",
                                                validateInput: true,
                                            });
                                            reject();
                                            return;
                                        }
                                        resolve();
                                        handlesearchgridattributes(newData);
                                    }, 600);
                                }),
                            onRowUpdate: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        handlesearchgridattributes(newData);
                                    }, 600);
                                })
                        }}

                    /></div>
            }
        </div>
    )

}